import React, { useState, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';

function AddUserPopup({ titleText, currentWholesalerName, handleDashboard, closePopup }) {
    const [loading, setLoading] = useState(false);
    const [userName, setUserName] = useState(currentWholesalerName || '');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        
        const newErrors = {};
        
        if (!userName) {
            newErrors.userName = 'Please enter user name';
        }
        
        if (!email) {
            newErrors.email = 'Please enter email id';
        } else if (!validateEmail(email)) {
            newErrors.email = 'Please enter valid email id';
        }
        
        setErrors(newErrors);
        
        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            handleDashboard([userName, email]);
        }
    }, [userName, email, handleDashboard]);

    const handleOpenChange = useCallback((open) => {
        if (!open) {
            closePopup();
        }
    }, [closePopup]);

    return (
        <Dialog open={true} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{titleText}</DialogTitle>
                </DialogHeader>
                
                <div className="flex flex-col gap-4">
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <div className="flex flex-col gap-2">
                            <Label htmlFor="userName">Name</Label>
                            <Input
                                id="userName"
                                type="text"
                                value={userName}
                                onChange={(e) => { setUserName(e.target.value); setErrors(prev => ({ ...prev, userName: '' })); }}
                                placeholder="Name"
                                className={errors.userName ? 'border-destructive' : ''}
                            />
                            {errors.userName && <p className="text-sm text-destructive">{errors.userName}</p>}
                        </div>
                        
                        <div className="flex flex-col gap-2">
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value); setErrors(prev => ({ ...prev, email: '' })); }}
                                placeholder="Email"
                                className={errors.email ? 'border-destructive' : ''}
                            />
                            {errors.email && <p className="text-sm text-destructive">{errors.email}</p>}
                        </div>
                    </form>
                </div>

                <DialogFooter>
                    <Button type="submit" disabled={loading} onClick={handleSubmit}>
                        {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
                        Create
                    </Button>
                    <Button type="button" variant="secondary" onClick={closePopup}>
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default AddUserPopup;
